const dba = {
  AGENCY_DIGIT_NUMERIC_ALSO_WITH_X: {
    message: 'Agency digit must be numeric or x'
  },
  ACCOUNT_DIGIT_NUMERIC_ALSO_WITH_X: {
    message: 'Account digit is required and must be numeric or x'
  },
  AGENCY_ONE: {
    message: 'Agency must be 1'
  },
  INVALID_AGENCY_ONE: {
    message: 'Agency must be 1'
  },
  AGENCY_MAX_LENGTH: {
    message: 'Agency is required and must contain a maximum of {{maxLength}} numbers'
  },
  AGENCY_DIGIT_NUMERIC: {
    message: 'Agency digit must be only 1 digit'
  },
  ACCOUNT_MAX_LENGTH: {
    message: 'Account is required and must have a maximum of {{maxLength}} numbers'
  },
  ACCOUNT_MAX_MIN_LENGTH: {
    message: 'Account is required and must have between {{minLength}} and {{maxLength}} numbers'
  },
  ACCOUNT_DIGIT_NUMERIC: {
    message: 'Account digit is required and must be only 1 digit'
  },
  ACCOUNT_EXACT_LENGTH: {
    message: 'Account is required and must contain exactly {{exactLength}} numbers'
  },
  ACCOUNT_TYPE: {
    message: 'Invalid account type'
  },
  ACCOUNT_TYPE_2: {
    message: 'Invalid account type'
  },
  ACCOUNT_TYPE_3: {
    message: 'Invalid account type'
  },
  ENTIDADE_PUBLICA_IS_JUST_FOR_CNPJ: {
    message: "Account type 'Entidade pública' is only available for CNPJ"
  },
  ENTIDADE_PUBLICA_IS_JUST_FOR_CNPJ_2: {
    message: "Account type 'Entidade pública' is only available for CNPJ"
  },
  INVALID_DOCUMENT: {
    message: 'Destination bank account document is not a CPF nor CNPJ'
  },
  INVALID_DOCUMENT_2: {
    message: 'Destination bank account document is not a CPF nor CNPJ'
  },
  INVALID_DOCUMENT_3: {
    message: 'Destination bank account document is not a CPF nor CNPJ'
  },
  DOCUMENT_BLACKLIST_BLOCKED: {
    message: 'Destination bank account document is blocked'
  },
  DOCUMENT_BLACKLIST_BLOCKED_2: {
    message: 'Destination bank account document is blocked'
  },
  BANK_NOT_FOUND: {
    message: 'Bank(s) not found by id or code'
  },
  INVALID_NAME: {
    message: 'The name is required'
  },
  INVALID_EMAIL: {
    message: 'The email must be valid'
  },
  EDIT_NOT_ALLOWED: {
    message: 'Destination Bank Account cannot be edited when status is Pending Verification or Verified'
  },
  REMOVE_NOT_ALLOWED_WITH_PROCESSING_TRANSFERS: {
    message: 'Destination Bank Account cannot be removed while having processing transfers'
  },
  INVALID_AGENCY_DIGIT: {
    message: 'Invalid agency digit'
  },
  ACCOUNT_OR_ACCOUNT_DIGIT_INVALID: {
    message: 'Invalid account or account digit'
  },
  INVALID_ACCOUNT_DIGIT: {
    message: 'Invalid account or account digit'
  },
  INVALID_ACCOUNT: {
    message: 'Invalid account'
  },
  AGENCY_DOES_NOT_EXIST: {
    message: 'Agency does not exist'
  },
  DOCUMENT_DOEST_NOT_EXIST: {
    message: 'Document does not exist'
  },
  DOCUMENT_DOEST_NOT_EXIST_2: {
    message: 'Document does not exist'
  },
  WRONG_DOCUMENT: {
    message: 'Informed document does not match with informed name'
  },
  EMPTY_PAYLOAD: {
    message: 'Payload is required'
  },
  INVALID_ACCOUNT_BEGINNING: {
    message: 'Invalid account. Account beginning {{accountBeginning}} is not valid'
  },
  INVALID_LEGAL_DOCUMENT: {
    message: 'Invalid legal {{document}} document'
  },
  INVALID_PHYSICAL_DOCUMENT: {
    message: 'Invalid physical {{document}} document'
  },
  AGENCY_ACCOUNT_TYPE_ACCOUNT_OR_ACCOUNT_DIGIT_INVALID: {
    message: 'Invalid agency, account type, account or account digit'
  },
  AGENCY_ACCOUNT_OR_ACCOUNT_DIGIT_INVALID: {
    message: 'Invalid agency, account or account digit'
  },
  AGENCY_ACCOUNT_OR_ACCOUNT_DIGIT_INVALID_2: {
    message: 'Invalid agency, account or account digit'
  },
  PROVIDED_BANK_ID_AND_CODE: {
    message: 'Destination Bank Account was provided with bank id and code, please provide only one bank info.'
  },
  ACCOUNT_IS_JUST_FOR_CNPJ: {
    message: 'Destination Bank Account belongs to a company (CNPJ).'
  },
  BANK_CODE_FORMAT_ERROR: {
    message: 'Bank Code is required and must have a maximum of 3 numbers'
  },
  BANK_CODE_NOT_FOUND: {
    message: 'This banking institution is not eligible to receive payments'
  },
  INVALID_NAME_LENGTH: {
    message: 'The name must have at least 3 characters'
  },
  INVALID_BANK_ID: {
    message: 'Bank ID must be a number'
  },
  REQUIRED_PIX_KEY_TYPE: {
    message: 'The PIX key type is required'
  },
  REQUIRED_PIX_KEY_VALUE: {
    message: 'The PIX key value is required'
  },
  INVALID_PIX_KEY_TYPE: {
    message: 'The PIX key type is invalid'
  },
  INVALID_PIX_KEY: {
    message: 'The PIX key value is invalid for the key type {{pix_key_type}}'
  }
};

module.exports = dba;
